import { Contact } from "./crm/contact";

export class User {
  id: number;
  username?: string;
  email?: string;
  user_type: UserType;
  role: UserRole;
  first_name?: string;
  last_name?: string;
  phone?: string;

  constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

  static defaultEmpty(): User {
    return new User({
      id: undefined,
      username: undefined,
      email: undefined,
      user_type: UserType.LEAD,
      role: UserRole.USER,
      first_name: undefined,
      last_name: undefined,
      phone: undefined,
    });
  }
}
export enum UserType {
  CLIENT = "CLIENT",
  AGENT = "AGENT",
  OPERATOR = "OPERATOR",
  LEAD = "LEAD",
  DEMO = "DEMO",
}

export enum UserRole {
  SUPERADMIN = "superadmin", // ניהול כללי
  COMPANY_ADMIN = "company_admin", // מנהל חברה
  USER = "user", // משתמש רגיל
}

export class UserPrivacyData {
  id: number;
  user_id: number;
  date_of_birth?: string;
  israeli_id?: string;
  cellular?: string;
  israeli_id_issued_at?: string;
  signature?: string;
  has_hever?: boolean;
  city?: string;
  street?: string;
  house_number?: string;
  usa_ssn?: string;
  marital_status?: string;
  children_count?: number;
  status?: string;
  last_contacted?: string;
  message?: string;
  next_activity_date?: string;
  lead_source?: LeadSource;
  lead_source_text?: string;

  constructor(init?: Partial<UserPrivacyData>) {
    Object.assign(this, init);
  }

  static defaultEmpty(): UserPrivacyData {
    return new UserPrivacyData({
      id: undefined,
      user_id: undefined,
      date_of_birth: undefined,
      israeli_id: undefined,
      cellular: undefined,
      israeli_id_issued_at: undefined,
      signature: undefined,
      has_hever: undefined,
      city: undefined,
      street: undefined,
      house_number: undefined,
      usa_ssn: undefined,
      marital_status: undefined,
      children_count: undefined,
      status: undefined,
      last_contacted: undefined,
      message: undefined,
      next_activity_date: undefined,
      lead_source: LeadSource.OTHER,
      lead_source_text: undefined,
    });
  }
}




export class CreateAndSendForClientSigningDTO  {
  contact: Contact;
  agent_id: string;
  create_user: boolean;
  auto_request_after_signature: boolean;
  request_pre_advice_files: boolean;
  request_insurance_files: boolean;
  send_form_for_signing: boolean;
  signed_date_iso?: string;

  constructor(init?: Partial<CreateAndSendForClientSigningDTO>) {
   
    Object.assign(this, init);
  }

  static defaultEmpty(): CreateAndSendForClientSigningDTO {
    return new CreateAndSendForClientSigningDTO({
      contact: Contact.defaultEmpty(),
      agent_id: undefined,
      create_user: false,
      auto_request_after_signature: false,
      request_pre_advice_files: false,
      request_insurance_files: false,
      send_form_for_signing: false,
      signed_date_iso: undefined,
    });
  }
}

export enum LeadSource {
  REFERRAL = "referral",
  GOOGLE_ADS = "google_ads",
  FACEBOOK = "facebook",
  LINKEDIN = "linkedin",
  AFFILIATE = "affiliate",
  OTHER = "other",
}